import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Checkbox, Typography, FormControlLabel,
} from '@mui/material';

function LinkMapFilters({ onClick }) {
  const [hubFilter, setHubFilter] = useState(false);
  const [geofenceFilter, setGeofenceFilter] = useState(false);
  const [pickupZoneFilter, setPickupZoneFilter] = useState(false);

  useEffect(() => {
    setHubFilter(JSON.parse(localStorage.getItem('hubFilter')));
    setGeofenceFilter(JSON.parse(localStorage.getItem('geofenceFilter')));
    setPickupZoneFilter(JSON.parse(localStorage.getItem('pickupZoneFilter')));
  }, []);

  useEffect(() => {
    onClick({
      hubFilter,
      geofenceFilter,
      pickupZoneFilter,
    });
    localStorage.setItem('hubFilter', hubFilter);
    localStorage.setItem('geofenceFilter', geofenceFilter);
    localStorage.setItem('pickupZoneFilter', pickupZoneFilter);
  }, [hubFilter, geofenceFilter, pickupZoneFilter]);

  const updateHubFilter = (setValue) => {
    setHubFilter(setValue);
    onClick({
      hubFilter: setValue,
      geofenceFilter,
      pickupZoneFilter,
    });
  };
  const updateGeofenceFilter = (setValue) => {
    setGeofenceFilter(setValue);
    onClick({
      geofenceFilter: setValue,
      hubFilter,
      pickupZoneFilter,
    });
  };
  const updatePickupZoneFilter = (setValue) => {
    setPickupZoneFilter(setValue);
    onClick({
      pickupZoneFilter: setValue,
      geofenceFilter,
      hubFilter,
    });
  };
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} sm="auto" sx={{ mb: { xs: -1, sm: 0 } }}>
        <Typography variant="subtitle2">
          <strong>Map Settings</strong>
        </Typography>
      </Grid>
      <FormControlLabel
        control={(
          <Checkbox
            checked={hubFilter || false}
            onClick={() => updateHubFilter(!hubFilter)}
          />
        )}
        label="Hubs"
        labelPlacement="start"
        sx={{ ml: { xs: 0, sm: 2 } }}
      />
      <FormControlLabel
        control={(
          <Checkbox
            checked={geofenceFilter || false}
            onClick={() => updateGeofenceFilter(!geofenceFilter)}
          />
        )}
        label="Geofences"
        labelPlacement="start"
      />
      <FormControlLabel
        control={(
          <Checkbox
            checked={pickupZoneFilter || false}
            onClick={() => updatePickupZoneFilter(!pickupZoneFilter)}
          />
        )}
        label="Pickup Zones"
        labelPlacement="start"
      />
    </Grid>
  );
}
LinkMapFilters.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LinkMapFilters;
